import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36e0c524&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0c524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e0c524')) {
      api.createRecord('36e0c524', component.options)
    } else {
      api.reload('36e0c524', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36e0c524&scoped=true&", function () {
      api.rerender('36e0c524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/TInput/index.vue"
export default component.exports